__turbopack_context__.v({
  "actionContainer": "OCwcsa_actionContainer",
  "cellContent": "OCwcsa_cellContent",
  "cellTooltipContent": "OCwcsa_cellTooltipContent",
  "contextDropdownContainer": "OCwcsa_contextDropdownContainer",
  "contextDropdownItem": "OCwcsa_contextDropdownItem",
  "contextDropdownWrapper": "OCwcsa_contextDropdownWrapper",
  "contextMenu": "OCwcsa_contextMenu",
  "detailRowCell": "OCwcsa_detailRowCell",
  "expandableRow": "OCwcsa_expandableRow",
  "expanderContent": "OCwcsa_expanderContent",
  "extraInfoIcon": "OCwcsa_extraInfoIcon",
  "gridContainer": "OCwcsa_gridContainer",
  "header": "OCwcsa_header",
  "iconChevronDown": "OCwcsa_iconChevronDown",
  "iconChevronUp": "OCwcsa_iconChevronUp",
  "linedRows": "OCwcsa_linedRows",
  "rightAlignCell": "OCwcsa_rightAlignCell",
  "rowAction": "OCwcsa_rowAction",
  "supplementalOnMobile": "OCwcsa_supplementalOnMobile",
  "table": "OCwcsa_table",
});
